// extracted by mini-css-extract-plugin
export default {"news":"index_news_jdS6d","newsFirstTitle":"index_newsFirstTitle_nHZj8","newsItem":"index_newsItem_nzD1Z","tuijian":"index_tuijian_GJ8h1","line":"index_line_14Nnz"};